<template>
	<div class="properties">

		<el-row>
			<el-col :span="24">
				<div class="intro">Properties</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="7">
				<div class="grid-content bg-purple-dark">
					<div class="rang-item">
						<el-form :inline="true" size="mini" class="demo-form-inline">
							<el-form-item label="Molecular weight:" style="width:120px"></el-form-item>
							<el-form-item label="">
								<el-input v-model="MW[0]" placeholder="100 Da" style="width:65px"></el-input>
							</el-form-item>
							<el-form-item label="to">
								<el-input v-model="MW[1]" placeholder="1200 Da" style="width:65px"></el-input>
							</el-form-item>
						</el-form>
						<div class="slider-range">
							<el-slider v-model="MW" range :min="100" :max="1000"></el-slider>
						</div>

					</div>
					<div class="rang-item">
						<el-form :inline="true" size="mini" class="demo-form-inline">
							<el-form-item label="LogP: " style="width:110px"></el-form-item>
							<el-form-item label="">
								<el-input v-model="LogP[0]" placeholder="-10" style="width:70px"></el-input>
							</el-form-item>
							<el-form-item label="to">
								<el-input v-model="LogP[1]" placeholder="10" style="width:70px"></el-input>
							</el-form-item>
						</el-form>
						<div class="slider-range">
							<el-slider v-model="LogP" range :min="-10" :max="10"></el-slider>
						</div>
					</div>

					<div class="rang-item">
						<el-form :inline="true" size="mini" class="demo-form-inline">
							<el-form-item label="Number of HB acceptors:" style="width:110px"></el-form-item>
							<el-form-item label="">
								<el-input v-model="HBA[0]" placeholder="0" style="width:70px"></el-input>
							</el-form-item>
							<el-form-item label="to">
								<el-input v-model="HBA[1]" placeholder="15" style="width:70px"></el-input>
							</el-form-item>
						</el-form>
						<div class="slider-range">
							<el-slider v-model="HBA" range :min="0" :max="15"></el-slider>
						</div>
					</div>

					<div class="rang-item">
						<el-form :inline="true"  size="mini" class="demo-form-inline">
							<el-form-item label="Number of HB donors:" style="width:110px"></el-form-item>
							<el-form-item label="">
								<el-input v-model="HBD[0]" placeholder="0" style="width:70px"></el-input>
							</el-form-item>
							<el-form-item label="to">
								<el-input v-model="HBD[1]" placeholder="15" style="width:70px"></el-input>
							</el-form-item>
						</el-form>
						<div class="slider-range">
							<el-slider v-model="HBD" range :min="0" :max="15"></el-slider>
						</div>
					</div>

					<div class="rang-item">
						<el-form ref="form"  label-width="130px">
							<el-form-item>
								<el-button type="primary" size="mini" @click="submitForm()">Search</el-button>
								<el-button size="mini" @click="resetForm()">Reset</el-button>
							</el-form-item>
						</el-form>
					</div>

				</div>
			</el-col>
			<el-col :span="17">
				<div class="grid-content">
					<!--数据表格-->
					<el-table :data="showData" v-loading="loading" stripe border fit empty-text="No Data"
						style="width: 100%;font-size: 18px;">
						<el-table-column prop="Inflam_id" label="InflamNat ID" width="130px" >
							<template slot-scope="scope">
								<el-link type="primary" @click="toDetail(scope.row.id)" style="font-size: 18px;">{{scope.row.Inflam_id}}</el-link>
							</template>
						</el-table-column>
						<el-table-column prop="Name" label="Name" width="220px"> </el-table-column>
						<el-table-column prop="img" label="Structure" width="130px">
							<template slot-scope="scope">
								<el-image style="width:100px; height: 100px" :src="scope.row.img" fit="fill"></el-image>
							</template>
						</el-table-column>
						<el-table-column prop="MW" label="Molecular Weight" width="155px"></el-table-column>
						<el-table-column prop="AlogP" label="AlogP" width="70px"></el-table-column>
						<el-table-column prop="HB_acc" label="HB_acc" width="70px"></el-table-column>
						<el-table-column prop="HB_don" label="HB_don" width="70px"></el-table-column>
						
						
						<el-table-column fixed="right" label="Detail">
							<template slot-scope="scope">
								<el-button @click="toDetail(scope.row.id)" type="text" size="small" style="font-size: 18px;">Detail</el-button>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="Bioactivity" width="110px">
							<template slot-scope="scope">
								<el-button @click="toAbout(scope.row.id)" type="text" size="small" style="font-size: 18px;">Bioactivity</el-button>
							</template>
						</el-table-column>
					</el-table>

					<div class="page-warp">
					  <el-pagination align="right" @current-change="currentChange" :current-page="page" :page-size="10" background
					  	layout="total, prev, pager, next, jumper" :total="total" />
					</div>
					<div class="down-load">
					  <el-button size="small" @click="downloadFile" type="success" round
					    >Download</el-button
					  >
					</div>
					<!-- <iframe v-show="false" :src="iframeurl" frameborder="0"></iframe> -->

				</div>
			</el-col>
		</el-row>

	</div>
</template>

<script>
	export default {
		name: "search_t",
		data() {

			return {
				MW: [100, 1000],
				LogP: [-10, 10],
				HBA: [0, 15],
				HBD: [0, 15],
				user: '',
				region: '',
				value: [1, 1000],
				tableData: [],
				currentNum: 1,
				loading: false,
				fileList: [],
				iframeurl: "",
				page:1,
				size:10,
				total:0,

			}
		},

		
		methods: {
			currentChange(num) {
				this.page = num;
				this.submitForm()
			},
			resetForm() {
				this.MW = [100, 1000]
				this.LogP = [-10, 10]
				this.HBA = [0, 15]
				this.HBD = [0, 15]
				this.page = 1;
				this.submitForm()
			},
			submitForm() {
				let _this = this
				this.loading = true;
				this.currentNum = 1;
				this.tableData = [];
				var form = {
					MW: _this.MW.toString() ==[100,1000].toString() ?'':_this.MW.toString(),
					LogP: _this.LogP.toString() ==[-10, 10].toString() ?'':_this.LogP.toString(),
					HBA: _this.HBA.toString() ==[0, 15].toString() ?'':_this.HBA.toString(),
					HBD: _this.HBD.toString() ==[0, 15].toString() ?'':_this.HBD.toString(),
					page:_this.page,
					size:_this.size
				};
				this.$http({
					url: "/api/rdkit/queryByProperties",
					params: form,
					method: "get",
				}).then((res) => {
					_this.showData = res.data.data.list
					_this.total = res.data.data.count
					_this.loading = false;
				});
			},
			
			async downloadFile() {
				const {
					structure,
					name
				} = this.form;
				const URL = `/api/exportCsv?structure=${structure}&name=${name}`
				const res = await this.$http.get(URL);
				const blob = new Blob([res.data], {
					type: res.headers['content-type']
				});
				let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
				let result = patt.exec(res.headers['content-disposition']);
				let filename = 'result.csv';
			
				const downloadElement = document.createElement('a');
				const href = window.URL.createObjectURL(blob);
			
				console.log(filename);
				downloadElement.style.display = 'none';
				downloadElement.href = href;
				downloadElement.download = filename; //下载后文件名
				document.body.appendChild(downloadElement);
				downloadElement.click(); //点击下载
				document.body.removeChild(downloadElement); //下载完成移除元素
				window.URL.revokeObjectURL(href); //释放掉blob对象
			},

			
			toDetail(id) {
				const {
					origin,
					pathname
				} = window.location;
				window.location.href = `${origin}${pathname}#/main/search/detail?id=${id}`;
				//   window.open(`${origin}${pathname}#/main/search/detail?id=${id}`);
			},
			
			toAbout(id) {
				const {
					origin,
					pathname
				} = window.location;
				window.location.href = `${origin}${pathname}#/main/search/about?id=${id}`;
				//   window.open(`${origin}${pathname}#/main/search/about?id=${id}`);
			},
		},
		mounted() {
			
			this.submitForm()
		}

	}
</script>

<style scoped>
	.properties {
		padding: 0 50px;
		margin: 0 auto;
	}

	.intro {
		margin: 0 0 20px 0;
		border-bottom: 2px solid rgb(245, 166, 20);
		line-height: 60px;
		text-align: center;
		font-size: 30px;
		color: #409EFF;
	}

	.rang-item {
		margin-bottom: 20px;
	}

	.el-form-item--mini.el-form-item,
	.el-form-item--small.el-form-item {
		margin-bottom: 0px;
	}

	.el-form-item {
		margin-bottom: 0px;
	}

	.bg-purple-dark {
		margin: 0px 20px 0 0;
		padding: 20px 10px 10px 10px;
		background: #f5f7f9;
		border: #e6ecf1 1px solid;
		box-sizing: border-box;
	}

	.slider-range {
		margin: 0 10px;
	}
	
	.page-warp {margin-top:10px;display:flex;justify-content:center;}
	.down-load {display:flex;justify-content:flex-end;}
</style>
